<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import ApiClassification from "@/components/modals/api-classification.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import { DraggableTree } from "vue-draggable-nested-tree";
import KpiTags from "@/components/modals/kpi-tags.vue";
import MainTargetTemplate from './main-target-template.vue';
import Switches from "vue-switches";
import PlanningRatingScale from "@/components/modals/planning-rating-scale.vue"
import LibPreReportBtn from '@/components/widgets/lib-pre-report-button.vue';
import TableAnnualTarget from '@/components/widgets/table-annual-target.vue';
import PrexcModal from "@/components/modals/prexc.vue"
import RawData from "@/components/widgets/raw-data.vue";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import UploadModal from "@/components/modals/upload-stock.vue";
import LogModal from "@/components/modals/log-modal.vue";

export default {
    page: {
        title: "KPI List",
    },
    components: {
        Layout,
        PageHeader,
        MaskedInput,
        ApiClassification,
        PrintOptions,
        DraggableTree,
        KpiTags,
        MainTargetTemplate,
        Switches,
        PlanningRatingScale,
        LibPreReportBtn,
        TableAnnualTarget,
        RawData,
        PrexcModal,
        UploadModal,
        LogModal
    },
    data() {
        return {
            title: "Program Cluster(s) and Area(s)",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Program Cluster(s) and Area(s)",
                    active: true,
                },
            ],
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: true,
            }),
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: "",
            filterOn: [],
            sortBy: "indicatorName",
            sortDesc: false,
            fields: [
                {
                    key: "item",
                    label: "",
                    thStyle: { width: "20px" },
                },
                {
                    key: "prexc.prexcName",
                    sortable: true,
                    label: "DYNAMIC/PREXC/KRA",
                },
                {
                    key: "prexc.prexcClassification.priority",
                    sortable: true,
                    label: "Classification Priority",
                },
                {
                    key: "actions",
                    thStyle: { width: "10%" },
                },
            ],
            form: {
                id: 0,
                indicatorName: "",
                prexcId: null,
            },
            kpiSelected: null,
            tableBusy: false,
            allIndicators: [],
            prexcs: [],
            prexc: null,

            // indicator item
            indicatorTypes: [
                {
                    value: "",
                    text: "Select Type",
                },
                {
                    text: "Output",
                    value: "Output",
                },
                {
                    text: "Outcome",
                    value: "Outcome",
                },
                {
                    text: "Impact",
                    value: "Impact",
                },
            ],
            priorityTypes: [
                {
                    value: "",
                    text: "Select Prioritization Type",
                },
                {
                    text: "Core",
                    value: "Core",
                },
                {
                    text: "Strategic",
                    value: "Strategic",
                },
                {
                    text: "Mandated",
                    value: "Mandated",
                },
                {
                    text: "Project Based",
                    value: "Project Based",
                },
                {
                    text: "Intervention",
                    value: "Intervention",
                },
            ],
            indicatorForm: {
                id: 0,
                indicatorItemName: "",
                type: "",
                indicatorItemClassificationId: "",
                finalRemarks: "",
                indicatorId: this.$route.params.id,
                sequence: 0,
                isPercentage: false,
                yearToBeComplied: "",
                isCompleted: false,
                isRecurring: false,
                allowDeliveryUnitToAddTag: false,
                showInPRE: false,
                allowText: false,
                showInAdminDashboard: false,
                points: "0",
                code: "",
                indicatorItemGroupId: null,
            },
            api: {
                id: 0,
                planningTemplateDeliveryUnitId: null,
                name: null,
                description: null,
                apiTypeId: null,
                priority: null,
                apiType: null,
            },
            target: {
                id: 0,
                indicatorItemId: null,
                description: null,
                overAllTarget: null,
                isPercentage: null,
                allowAdd: null,
                isLocked: null,
                overAllTargetText: null
            },
            apiClassification: "",
            indicatorItemClassification: {},
            glow: false,
            filterBy: "all",
            itemClassifications: [],
            selectedIndicator: null,
            searchIndicator: false,
            selectedPrexc: null,
            selectedIndicatorToTransfer: null,
            selectedTagIndicatorItem: null,
            prexcParent: null,
            addOutside: false,
            moveIndicatorItem: null,
            selectedCampus: null,
            selectedClassification: null,
            selectedPrexcFR: null,
            prexcList: [],
            reportSelection: 0,
            apiData: [],
            viewingApi: false,
            addApi: false,
            selectedDU: null,
            apiLoading: false,
            parentIndicatorItem: null,
            transferFilter: null,
            transferObject: 'kpi',
            selectedKPI: null,
            kpiGroups: [],
        };
    },
    validations: {
        form: {
            indicatorName: { required },
            prexcId: { required },
        },
        indicatorForm: {
            indicatorItemName: { required },
            type: { required },
            indicatorItemClassificationId: { required },
            yearToBeComplied: { required },
            points: { required },
            overAllTarget: { required },
        },
        api: {
            name: { required },
            description: { required },
            apiTypeId: { required },
        },
        target: {
            indicatorItemId: { required },
            description: { required },
        },
    },
    computed: {
        filteredTable() {
            let data = this.tableData;
            if (this.filterBy == "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase());
                    });
                }
                return data;
            } else {
                return data.filter((item) => {
                    return item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
        },
        filteredTransferTable() {
            let data = this.tableData;
            if (this.transferFilter && this.transferFilter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.transferFilter.toUpperCase());
                });
            }
            return data;
        },
        rows() {
            let data = this.tableData;
            if (this.filterBy == "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase());
                    });
                }
            } else {
                data = data.filter((item) => {
                    item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        groupedPrexc() {
            var array = [];
            var group = groupBy(this.prexcList, "prexcClassificationId");
            for (const key in group) {
                array.push({
                    id: key,
                    classification: group[key][0].prexcClassification.classification,
                    prexcList: group[key]
                });
            }
            return array;
        }
    },
    created() {
        this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.totalRows = this.items.length;
        this.$store
            .dispatch("prexc/GetPrexc")
            .then((res) => {
                this.prexcs = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        this.$store
            .dispatch(
                "indicatoritemclassification/GetIndicatorItemClassification"
            )
            .then((res) => {
                this.itemClassifications = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        this.$store.dispatch("indicatoritemgroup/GetIndicatorItemGroup")
            .then((res) => {
                this.kpiGroups = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        let years = [];
        let currentYear = new Date().getFullYear();
        for (let i = 0; i < 5; i++) {
            years.push(currentYear + i);
        }
        for (let i = 1; i < 5; i++) {
            years.unshift(currentYear - i);
        }
        this.years = years;
        this.$store
            .dispatch("prexc/GetPrexc")
            .then((res) => {
                this.prexcList = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
    },
    methods: {
        async changeData(cycle, campusId) {
            this.tableBusy = true;
            await this.getAllIndicators();
            this.tableBusy = false;
        },
        async getAllIndicators() {
            await this.$store
                .dispatch("indicator/GetIndicator")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        item.showDetails = false;
                        item.updateSequence = false;
                        item.multipleSelection = false;
                        item.indicatorItemLoading = false;
                        item.fetchedIndicatorItems = [];
                        item.prexcGrp = item.prexc.replace(/\s/g, '').toLowerCase();
                        item.prexcClassGrp = item.prexcClassification.replace(/\s/g, '').toLowerCase();
                        item.searchFilter = '';
                        item.filterKey = item.prexc + ' ' + item.indicatorName;
                        item.indicatorItems.map(x => {
                            item.filterKey += ` ${x.indicatorItemName}`;
                            x.filterKey = `${item.prexcClassGrp} ${item.prexcGrp} ${x.indicatorItemName}`
                        })
                    });
                    let classGrp = groupBy(res.data, 'prexcClassGrp');
                    let grpData = [];
                    for (const [key, value] of Object.entries(classGrp)) {
                        let grp = groupBy(value, 'prexcGrp');
                        let resData = [];
                        let itemClasses = [];
                        let upFilterKey = "";
                        for (const [gKey, gValue] of Object.entries(grp)) {
                            let filterKey = "";
                            gValue.forEach(gV => {
                                gV.indicatorItems.forEach((x) => {
                                    filterKey += x.indicatorItemName + " ";
                                    if (!itemClasses.find(w => w == x.indicatorItemClassification)) {
                                        itemClasses.push(x.indicatorItemClassification);
                                    }
                                    upFilterKey += x.indicatorItemName + " ";
                                });
                                filterKey += gV.indicatorName + " ";
                                upFilterKey += gV.indicatorName + " ";
                                gV.rotateChev = true;
                            })
                            resData.push({
                                id: gValue[0].prexcId,
                                prexc: gValue[0].prexc,
                                items: gValue,
                                rotateChevy: false,
                                rotateChev: true,
                                filterKey: filterKey + ` ${gValue[0].prexc}`,
                                searchClass: itemClasses.join(" ")
                            });
                            upFilterKey += gValue[0].prexc + " " + gValue[0].indicatorName;
                        }
                        grpData.push({
                            id: key,
                            prexcClass: value[0].prexcClassification,
                            items: resData,
                            filterKey: upFilterKey + ` ${value[0].prexcClassification}`,
                            searchClass: itemClasses.join(" "),
                            showOpts: false,
                            rotateChevy: true,
                            rotateChev: false
                        });
                    }
                    this.tableData = grpData.sort((a, b) => a.prexcClass.localeCompare(b.prexcClass));
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addFC() {
            this.addOutside = true;
            this.onReset();
            this.modalTitle = "Create New PAP & PREXC Group";
            this.$bvModal.show("modal-standard");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            console.log('form', this.form);
            if (this.form.id > 0) {
                this.$store
                    .dispatch("indicator/UpdateIndicator", this.form)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.selectedIndicator.indicatorName = cloneDeep(this.form.indicatorName);
                        this.prexcParent.items.splice(this.prexcParent.items.findIndex((x) => x.id == this.form.id), 1, this.selectedIndicator);
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store
                    .dispatch("indicator/CreateIndicator", this.form)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if (this.addOutside) {
                            this.changeData(this.$store.state.data.cycle);
                        } else {
                            res.data.indicatorItems = [];
                            res.data.fetchedIndicatorItems = [];
                            // res.data.prexcClassGrp = res.data.prexc.prexcClassification.classification.replace(/\s/g, '').toLowerCase();
                            // res.data.prexcGrp = res.data.prexc.prexcName.replace(/\s/g, '').toLowerCase();
                            res.data.searchFilter = '';
                            res.data.rotateChevy = false;
                            res.data.showDetails = false;
                            res.data.updateSequence = false;
                            res.data.indicatorItemLoading = false;
                            this.prexcParent.items.push(res.data);
                        }
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        onReset() {
            this.form = {
                id: 0,
                indicatorName: "",
                prexcId: null,
            };
            this.prexc = null;
        },
        selectPrexc(value) {
            this.form.prexcId = value.id;
        },
        viewItem(id) {
            this.$router.push(`/planning/indicator-item/${id}`);
        },
        showGrpDtls(row) {
            row.rotateChevy = !row.rotateChevy;
            if (row.rotateChevy) {
                if (this.filter && this.filter.trim() !== "") {
                    this.getIndicatorItems(this.filteredTab(row.items)[0]);
                } else {
                    this.getIndicatorItems(row.items[0]);
                }
            }
        },
        async getIndicatorItems(row) {
            row.indicatorItemLoading = true;
            row.fetchedIndicatorItems = [];
            await this.$store
                .dispatch("indicatoritem/GetParentIndicatorItem", {
                    id: row.id,
                    cycle: this.$store.state.data.cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = 1;
                    const isAdmin = this.$store.state.decrypt.isAdmin();
                    res.data.map((x) => {
                        x.index = index;
                        x.indicatorItemVisibility = false;
                        x.targetVisible = false;
                        x.detailVisible = false;
                        x.mainTargetVisible = false;
                        x.mainTargets = [];
                        x.mainTargetLoading = false;
                        x.singleSelection = true;
                        x.selectedTargets = [];
                        x.isSelected = false;
                        x.annualTargets = [];
                        x.anTargetLoading = false;
                        x.editBaseline = false;
                        x.baselineCopy = x.kpiBaseLines && x.kpiBaseLines.length ? cloneDeep(x.kpiBaseLines[0].baseLine) : '';
                        x.baselineId = x.kpiBaseLines && x.kpiBaseLines.length ? cloneDeep(x.kpiBaseLines[0].id) : null;
                        x.baseline = x.kpiBaseLines && x.kpiBaseLines.length ? cloneDeep(x.kpiBaseLines[0].baseLine) : 0;
                        x.filterKey = `${row.prexcClassification} ${row.prexc} ${row.indicatorName} ${x.indicatorItemName}`
                        x.showActions = false;
                        if (x.childItems && x.childItems.length > 0) {
                            this.recurseCheckChild(x.childItems, index, row)
                        }
                        x.children = !isAdmin && x.childItems ? x.childItems.filter(c => !c.hidden) : (x.childItems || []);
                        index++;
                    });
                    row.fetchedIndicatorItems = isAdmin ? res.data : res.data.filter(x => !x.hidden);
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            row.indicatorItemLoading = false;
        },
        recurseCheckChild(node, value, parent) {
            const isAdmin = this.$store.state.decrypt.isAdmin();
            for (var i = 0, count = node.length; i < count; i++) {
                let item = node[i];
                item.index = value + "." + (i + 1);
                item.children = !isAdmin && item.childItems ? item.childItems.filter(c => !c.hidden) : (item.childItems || []);
                item.indicatorItemVisibility = false;
                item.targetVisible = false;
                item.detailVisible = false;
                item.mainTargetVisible = false;
                item.mainTargets = [];
                item.mainTargetLoading = false;
                item.singleSelection = true;
                item.selectedTargets = [];
                item.isSelected = false;
                item.annualTargets = [];
                item.anTargetLoading = false;
                item.editBaseline = false;
                item.baselineCopy = item.kpiBaseLines && item.kpiBaseLines.length ? cloneDeep(item.kpiBaseLines[0].baseLine) : '';
                item.baselineId = item.kpiBaseLines && item.kpiBaseLines.length ? cloneDeep(item.kpiBaseLines[0].id) : null;
                item.baseline = item.kpiBaseLines && item.kpiBaseLines.length ? cloneDeep(item.kpiBaseLines[0].baseLine) : 0;
                item.filterKey = `${parent.prexcClassification} ${parent.prexc} ${parent.indicatorName} ${item.indicatorItemName}`;
                item.showActions = false;
                if (item.childItems && item.childItems.length > 0) {
                    this.recurseCheckChild(item.childItems, item.index, parent)
                }
            }
        },
        toggleSequence(row) {
            row.fetchedIndicatorItems.map(item => {
                item.indicatorItemVisibility = false
            });
            var sequence = cloneDeep(row.updateSequence);
            this.tableData.map((item) => {
                item.updateSequence = false;
            });
            if (!sequence) {
                this.seqArray = [];
            }
            row.updateSequence = !sequence;
        },
        viewTargets(id) {
            this.$router.push(`/planning/target/${id}`);
        },
        onResetIndicatorItem() {
            this.indicatorForm = {
                id: 0,
                indicatorItemName: "",
                type: "",
                indicatorItemClassificationId: "",
                finalRemarks: "",
                sequence: 0,
                isPercentage: false,
                yearToBeComplied: new Date().getFullYear().toString(),
                isCompleted: false,
                isRecurring: false,
                allowDeliveryUnitToAddTag: false,
                showInPRE: false,
                overAllTarget: '0',
                points: "0",
                code: "",
                indicatorItemGroupId: 0,
                showInAdminDashboard: false,
            };
            this.indicatorItemClassification = {};
        },
        addIndicatorItem(row) {
            this.onResetIndicatorItem();
            this.kpiSelected = row;
            this.modalTitle = "Create New Indicator Item";
            this.$bvModal.show("indicator-item-modal");
        },
        async onCreateIndicatorItem() {
            this.submitted = true;
            this.$v.indicatorForm.$touch();
            if (this.$v.indicatorForm.$invalid) {
                return;
            }
            var data = cloneDeep(this.indicatorForm);
            if (this.indicatorForm.id > 0) {
                var yIndex = this.kpiSelected.indicatorItems.findIndex((x) => x.id == this.indicatorForm.id);
                await this.$store
                    .dispatch("indicatoritem/UpdateIndicatorItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "warning"
                            );
                        }
                        data.indicatorItemClassification = this.indicatorItemClassification;
                        this.kpiSelected.indicatorItems.splice(yIndex, 1, data);
                        this.getIndicatorItems(this.kpiSelected)
                        this.$bvModal.hide("indicator-item-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                data.sequence = this.kpiSelected.indicatorItems.length + 1;
                data.indicatorId = this.kpiSelected.id;
                data.indicatorItemVisibility = false;
                await this.$store
                    .dispatch("indicatoritem/CreateIndicatorItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "warning");
                        }
                        data.id = res.data.id;
                        data.indicatorItemClassification = this.indicatorItemClassification;
                        this.kpiSelected.indicatorItems.push(data);
                        this.getIndicatorItems(this.kpiSelected)
                        this.$bvModal.hide("indicator-item-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        updateIndicatorItem(props, row) {
            this.indicatorForm = {
                id: props.id,
                indicatorItemName: props.indicatorItemName,
                type: props.type,
                indicatorItemClassificationId: props.indicatorItemClassificationId,
                finalRemarks: props.finalRemarks,
                sequence: props.sequence,
                isPercentage: props.isPercentage,
                isCompleted: props.isCompleted,
                isRecurring: props.isRecurring,
                indicatorId: props.indicatorId,
                yearToBeComplied: props.yearToBeComplied,
                allowDeliveryUnitToAddTag: props.allowDeliveryUnitToAddTag,
                code: props.code,
                showInPRE: props.showInPRE,
                allowText: props.allowText,
                showInAdminDashboard: props.showInAdminDashboard,
                overAllTargetText: props.overAllTargetText || '',
                indicatorItemGroupId: props.indicatorItemGroupId,
            }
            this.indicatorItemClassification = props.indicatorItemClassification;
            this.indicatorForm.points = props.points.toString();
            this.indicatorForm.overAllTarget = props.overAllTarget.toString();
            this.kpiSelected = row;
            this.modalTitle = "Update Indicator Item";
            this.$bvModal.show("indicator-item-modal");
        },
        deleteIndicatorItem(props, row) {
            var yIndex = row.indicatorItems.findIndex((x) => x.id == props.id);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("indicatoritem/DeleteIndicatorItem", props.id)
                        .then((res) => {
                            if (res.status == 204) {
                                row.indicatorItems.splice(yIndex, 1);
                                this.getIndicatorItems(row)
                                this.showToast("Successfully deleted!", "success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        getClassificationIdByName(name) {
            let classification = this.itemClassifications.find(x => x.classification.includes(name));
            return classification ? classification.id : null;
        },
        uploadIndicatorItem(row) {
            this.kpiSelected = row;
            this.$bvModal.show("modal-excel");
        },
        uploadKpi(arr) {
            let finArr = [];
            let errors = [];
            arr.map((item, index) => {
                let newData = {};
                Object.keys(item).forEach(key => {
                    if (key.includes('Allow_DU_to_add_tag')) {
                        newData.allowDeliveryUnitToAddTag = item[key];
                    } else if (key.includes('Is_Percentage')) {
                        newData.isPercentage = item[key];
                    } else if (key.includes('Is_Recurring')) {
                        newData.isRecurring = item[key];
                    } else if (key.includes('KPI_Classification')) {
                        newData.kpiClassification = item[key] || null;
                    } else if (key.includes('KPI_Code')) {
                        newData.code = item[key].toString();
                    } else if (key.includes('KPI_Name')) {
                        newData.indicatorItemName = item[key];
                    } else if (key.includes('KPI_Type')) {
                        newData.type = item[key];
                    } else if (key.includes('Overall_Target')) {
                        newData.overAllTarget = item[key].toString();
                    } else if (key.includes('Points')) {
                        newData.points = item[key].toString();
                    } else if (key.includes('Show in PRE')) {
                        newData.showInPRE = item[key];
                    } else if (key.includes('Year_to_be_complied')) {
                        newData.yearToBeComplied = item[key];
                    }
                });
                newData.indicatorId = this.kpiSelected.id;
                newData.parentId = 0;
                newData.indicatorItemClassificationId = this.getClassificationIdByName(newData.kpiClassification);
                if (!newData.indicatorItemClassificationId) {
                    errors.push(`Row ${index + 2}: Invalid KPI Classification`);
                }
                finArr.push(newData);
            });
            if (errors.length > 0) {
                this.$bvModal.hide("modal-excel");
                this.showToast(errors.join('<br>'), "error", 10000);
                return;
            }
            this.saveMultipleIndicatorItems(finArr)
        },
        async saveMultipleIndicatorItems(arr) {
            try {
                const { data: response } = await this.$store.dispatch("indicatoritem/AddIndicatorItems", arr);
                if (response.error) {
                    this.showToast(response.errorMessage, "error");
                }
                this.getIndicatorItems(this.kpiSelected)
                this.$bvModal.hide("modal-excel");
                this.showToast("Successfully uploaded!", "success");
            } catch (e) {
                this.showToast("Something went wrong!", "error");
            }
        },
        hideIndicatorItem(props) {
            let status = !props.hidden;
            props.showActions = false;
            this.$store
                .dispatch("indicatoritem/HideIndicatorItem", {
                    id: props.id,
                    status
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    props.hidden = status;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        updateSequence(row) {
            this.$store
                .dispatch(
                    "indicatoritem/UpdateIndicatorItemSequence",
                    this.seqArray
                )
                .then((res) => {
                    if (res) {
                        var xIndex = this.tableData.findIndex(
                            (x) => x.id == row.id
                        );
                        this.seqArray.forEach((item) => {
                            var data = this.tableData[xIndex].indicatorItems.find((y) => y.id == item.id);
                            data.sequence = item.sequence;
                        });
                        this.tableData[xIndex].indicatorItems.sort((a, b) => a.sequence - b.sequence);
                        row.updateSequence = false;
                        this.showToast(
                            "Successfully updated sequence!",
                            "success"
                        );
                    }
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        getApiClass() {
            this.$bvModal.show("api-classification-modal");
        },
        dropClass(data) {
            this.indicatorItemClassification = data;
            this.indicatorForm.indicatorItemClassificationId = data.id;
        },
        async printBar1PRO({ apiUrl, routeVar }) {
            this.$refs.printOpt.putOptions({
                apiUrl: apiUrl,
                routeVariables: routeVar,
            });
            this.$bvModal.show("print-options-modal");
        },
        async printVariance({ apiUrl, routeVar }) {
            this.$refs.printOpt.putOptions({
                apiUrl: apiUrl,
                routeVariables: routeVar,
            });
            this.$bvModal.show("print-options-modal");
        },
        async printLIB(selectedFS) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/FundSource/LIB",
                routeVariables: [this.$store.state.data.cycle, selectedFS],
            });
            this.$bvModal.show("print-options-modal");
        },
        printPRE({ url, routeVar }) {
            this.$refs.printOpt.putOptions({
                apiUrl: url,
                routeVariables: routeVar,
            });
            this.$bvModal.show("print-options-modal");
        },
        cancelGlow() {
            if (this.glow) {
                this.tableData.map((item) => {
                    item.indicatorItems.map((indicatorItem) => {
                        indicatorItem.glow = false;
                    });
                });
            }
        },
        filterIndicatorItems(data, searchFilter = null) {
            let filteredData = [];
            if (this.filterBy === "all") {
                filteredData = data;
            } else {
                filteredData = data.filter((item) => item.indicatorItemClassification && item.indicatorItemClassification.classification === this.filterBy);
            }
            if (this.filter && this.filter.trim() != "") {
                filteredData = filteredData.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            if (searchFilter && searchFilter.trim() != "") {
                filteredData = filteredData.filter((item) => {
                    return item.indicatorItemName
                        .toUpperCase()
                        .includes(searchFilter.toUpperCase());
                });
            }
            return filteredData;
        },
        onDropIndicatorItem(node, parent) {
            this.$store
                .dispatch("indicatoritem/UpdateParentId", { indicatorItemId: node.id, parentId: node.parent.isRoot ? 0 : node.parent.id })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.recalculateIndex(parent.fetchedIndicatorItems);
        },
        recalculateIndex(data) {
            let index = 1;
            const isAdmin = this.$store.state.decrypt.isAdmin();
            data.forEach((x) => {
                x.index = index;
                if (x.childItems && x.childItems.length > 0) {
                    this.recurseCheckChild(x.childItems, index)
                }
                x.children = !isAdmin && x.childItems ? x.childItems.filter(c => !c.hidden) : (x.childItems || []);
                index++;
            });
        },
        showLogs(item, customTitle = "") {
            const title = customTitle || (item?.targetLogs && item?.description
                ? `${item.description} Logs`
                : (item?.indicatorItemName
                    ? `${item.indicatorItemName} Logs`
                    : (item?.description ? `${item.description} Logs` : (item?.name ? `${item.name} Logs` : "Indicator Item Logs"))));
            this.$bvModal.show("log-modal");
            const logs = item?.indicatorItemLogs || item?.targetLogs || item?.logs || item;
            this.$refs.logModal.setLogs(logs, title);
        },
        transferIndicatorItems(arr, parent) {
            this.selectedPrexc = null;
            this.selectedIndicator = parent;
            this.selectedItems = [];
            arr.map(item => this.selectedItems.push(item.id));
            this.modalTitle = 'Transfer to another DYNAMIC/PREXC/KRA'
            this.$bvModal.show("transfer-item-modal");

        },
        async transferNow(row, type) {
            let data = [];
            if (type == 'kpi') {
                this.selectedItems.map(item => {
                    data.push({
                        id: item,
                        indicatorId: row.id
                    })
                })
            } else {
                this.selectedTargets.map(item => {
                    data.push({
                        id: item.id
                    })
                })
            }
            Swal.fire({
                text: `Are you sure you want to transfer selected ${type == 'kpi' ? 'kpi(s)' : 'targets'}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, transfer it!",
            }).then(async (result) => {
                if (result.value) {
                    if (type == 'kpi') {
                        await this.$store
                            .dispatch("indicatoritem/TransferIndicatorItem", data)
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                this.selectedIndicator.multipleSelection = false;
                                this.selectedItems.map(item => {
                                    let index = this.selectedIndicator.fetchedIndicatorItems.findIndex(x => x.id == item);
                                    this.selectedIndicator.fetchedIndicatorItems.splice(index, 1);
                                })
                                this.getIndicatorItems(row);
                                this.$bvModal.hide("transfer-item-modal");
                                this.showToast("Successfully transferred!", "success");
                            })
                            .catch((err) => {
                                this.showToast("Something went wrong!", "error");
                            });
                    } else {
                        await this.$store
                            .dispatch("planningtemplatemaintarget/TransferToAnotherKPI", {
                                id: row.id,
                                array: data,
                            })
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                let kpi = this.selectedIndicator.fetchedIndicatorItems.find(x => x.id == this.selectedKPI.id);
                                if (kpi) kpi.targetVisible = false;
                                this.$bvModal.hide("transfer-item-modal");
                                this.showToast("Successfully moved!", "success");
                            })
                            .catch((err) => {
                                this.showToast("Something went wrong!", "error");
                            });
                    }

                }
            })
        },
        addTags(indicatorItem) {
            this.selectedTagIndicatorItem = indicatorItem;
            this.$refs.kpiTags.resetTags(indicatorItem.tags);
            this.$bvModal.show('kpi-tag-modal')
        },
        dropKpiTags($event) {
            let tags = $event.map(x => x.id);
            this.$store
                .dispatch("indicatoritemtag/AddTagToIndicatorItem", {
                    indicatorItemId: this.selectedTagIndicatorItem.id,
                    tagIds: tags
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    this.getTags(this.selectedTagIndicatorItem)
                    this.$bvModal.hide("kpi-tag-modal");
                    this.showToast("Successfully tagged!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        showMainTargets(data) {
            data.detailVisible = false;
            if (data.indicatorItemVisibility && !data.targetVisible) {
                data.targetVisible = true;
                data.mainTargets = [];
                return this.viewMainTargets(data);
            }
            data.indicatorItemVisibility = !data.indicatorItemVisibility;
            data.targetVisible = !data.targetVisible;
            if (data.targetVisible) {
                data.mainTargets = [];
                this.viewMainTargets(data);
            }
        },
        async showKpiDetails(data) {
            data.targetVisible = false;
            if (data.indicatorItemVisibility && !data.detailVisible) {
                data.detailVisible = true;
                data.anTargetLoading = true;
                await this.getAnnualTargets(data);
                data.anTargetLoading = false;
                return;
            }
            data.indicatorItemVisibility = !data.indicatorItemVisibility;
            data.detailVisible = !data.detailVisible;
            if (data.detailVisible) {
                data.anTargetLoading = true;
                await this.getAnnualTargets(data)
                data.anTargetLoading = false;
            }
        },
        async getAnnualTargets(row) {
            this.$store
                .dispatch("kpiannualtarget/GetKPIAnnualTarget", {
                    campusId: this.$store.state.data.selectedCampus.id,
                    indicatorItemId: row.id
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => item.editMode = false);
                    row.annualTargets = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        getTags(row) {
            row.tags = [];
            this.$store
                .dispatch("indicatoritemtag/GetTagFromIndicatorItem", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.name = item.tag.name;
                    })
                    row.tags = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async viewMainTargets(row) {
            row.mainTargetLoading = true;
            await this.$store
                .dispatch("planningtemplatemaintarget/GetAllPTMTByIndicatorItem", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach(item => {
                        item.visible = false;
                        item.addDU = false;
                        item.mandatoryVisible = false;
                        item.mandatoryApis = cloneDeep(this.mandatoryApis);
                        item.targetTemplateDeliveryUnits = [];
                        item.loadDU = false;
                        item.selectedTarget = false;
                        item.zIndex = 0;
                    })
                    row.mainTargets = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            row.mainTargetLoading = false;
        },
        deleteTag(row, parent) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("indicatoritemtag/RemoveTagFromIndicatorItem", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.tags.findIndex(x => x.id == row.id);
                            parent.tags.splice(index, 1);
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        filteredPrexc(items, type = 'view') {
            let data = items;
            if (type === 'transfer') {
                if (this.transferFilter && this.transferFilter.trim() != "") {
                    data = data.filter((item) => {
                        return item.filterKey
                            .toUpperCase()
                            .includes(this.transferFilter.toUpperCase());
                    });
                }
            }
            if (this.filterBy == "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase());
                    });
                }
                return data;
            } else {
                return data.filter((item) => {
                    return item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
        },
        updateOutcome(props, parent) {
            this.form = {
                id: cloneDeep(props.id),
                indicatorName: cloneDeep(props.indicatorName),
                prexcId: cloneDeep(props.prexcId),
            };
            this.selectedIndicator = { ...props };
            this.prexcParent = parent;
            this.modalTitle = "Update PAP";
            this.$bvModal.show("modal-standard");
        },
        removeOutcome(props, parents) {
            var index = parents.items.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("indicator/DeleteIndicator", props.id)
                        .then((res) => {
                            if (res.status == 204) {
                                parents.items.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        addIndicator(parent) {
            this.addOutside = false;
            this.form = {
                id: 0,
                indicatorName: "",
                prexcId: parent.id,
            };
            this.prexcParent = parent;
            this.modalTitle = "Create New PAP";
            this.$bvModal.show("modal-standard");
        },
        handleMouseDown(e, item, parent) {
            this.moveIndicatorItem = item;
            this.kpiSelected = parent;
            e.target.style.cursor = 'grabbing';
            e.target.parentNode.parentNode.parentNode.setAttribute('draggable', 'true');
        },
        handleMouseUp(e, item) {
            e.target.style.cursor = 'grab';
            e.target.parentNode.parentNode.parentNode.setAttribute('draggable', 'false');
        },
        onDropZone(e, item) {
            if (this.moveIndicatorItem.indicatorId == item.id) {
                return;
            }
            let data = {
                id: this.moveIndicatorItem.id,
                indicatorItemName: this.moveIndicatorItem.indicatorItemName,
                type: this.moveIndicatorItem.type,
                finalRemarks: this.moveIndicatorItem.finalRemarks,
                indicatorItemClassificationId: this.moveIndicatorItem.indicatorItemClassificationId,
                indicatorId: item.id,
                sequence: this.moveIndicatorItem.sequence,
                points: this.moveIndicatorItem.points,
                isPercentage: this.moveIndicatorItem.isPercentage,
                yearToBeComplied: this.moveIndicatorItem.yearToBeComplied,
                isCompleted: this.moveIndicatorItem.isCompleted,
                parentId: this.moveIndicatorItem.parentId,
                overAllTarget: this.moveIndicatorItem.overAllTarget,
                isRecurring: this.moveIndicatorItem.isRecurring,
                standard: this.moveIndicatorItem.standard,
                allowDeliveryUnitToAddTag: this.moveIndicatorItem.allowDeliveryUnitToAddTag
            }
            Swal.fire({
                title: 'Are you sure?',
                text: `You want to move this indicator item to '${item.indicatorName}'?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, transfer it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.$store
                        .dispatch("indicatoritem/UpdateIndicatorItem", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            this.getIndicatorItems(this.kpiSelected)
                            this.showToast("Successfully transferred!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            })
        },

        viewAPIs(row) {
            this.selectedDU = row;
            this.modalTitle = 'View APIs';
            this.$bvModal.show("api-modal");
            this.addApi = false;
            this.viewingApi = false;
            this.getAPI(row, 'template');
        },
        async getAPI(row, type) {
            this.apiLoading = true;
            this.apiData = [];
            if (type === 'template') {
                await this.$store
                    .dispatch(
                        "planningtemplateapi/GetPlanningTemplateApi",
                        row.id
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.map((item) => {
                            item.editMode = false;
                        });
                        this.apiData = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                await this.$store
                    .dispatch(
                        "api/GetApiByTarget",
                        row.id
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if (!res.data.map) {
                            return;
                        }
                        res.data.map((item) => {
                            item.editMode = false;
                        });
                        this.apiData = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.apiLoading = false;
        },
        viewRubric(row) {
            this.selectedPlanningMainTarget = row;
            this.$refs.PlanningRatingScale.setMeasurement(row, 'du');
            this.$bvModal.show("performance-rating-modal");
        },
        resetApi() {
            this.api = {
                id: 0,
                planningTemplateDeliveryUnitId: 0,
                name: '',
                description: '',
                apiTypeId: '',
                priority: false,
                apiType: {
                    type: '',
                },
            };
            this.$v.api.$reset();
        },
        addMoreApi() {
            this.addApi = !this.addApi;
            if (this.addApi) {
                this.resetApi();
            }
        },
        deleteMainTarget(rows, parent) {
            let array = [];
            rows.map(item => {
                array.push(item.id);
            })
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    let error = 0;
                    for await (const x of array) {
                        await this.$store
                            .dispatch(
                                "planningtemplatemaintarget/DeletePTMT",
                                x
                            )
                            .then((res) => {
                                if (res.data.error) {
                                    error++;
                                }
                                let index = parent.mainTargets.findIndex((y) => y.id == x);
                                parent.mainTargets.splice(index, 1);
                            })
                            .catch((err) => {
                                error++;
                            });
                    }
                    if (error > 0) {
                        this.showToast('Something went wrong', 'error')
                    } else {
                        parent.selectedTargets = []
                        this.showToast('Successfully removed', 'success')
                    }
                }
            });
        },
        createNewTarget(row) {
            this.parentIndicatorItem = row;
            this.onResetTarget(row);
            this.modalTitle = "Create New Target";
            this.$bvModal.show("create-target-modal");
        },
        onResetTarget(row) {
            this.target = {
                id: 0,
                planningTemplateId: 0,
                indicatorItemId: cloneDeep(row.id),
                description: cloneDeep(row.indicatorItemName),
                overAllTarget: "",
                overAllTargetText: "",
                isPercentage: row.isPercentage,
                allowAdd: false,
                isLocked: false,
            };
        },
        updateMainTarget(row, parent) {
            this.parentIndicatorItem = parent;
            this.target = cloneDeep(row);
            this.target.overAllTarget = row.overAllTarget.toString();
            this.modalTitle = "Update Main Target";
            this.$bvModal.show("create-target-modal");
        },
        async onCreateTarget() {
            this.submitted = true;
            this.$v.target.$touch();
            if (this.$v.target.$invalid) {
                return;
            }
            if (this.parentIndicatorItem.allowText) {
                this.target.overAllTarget = 0;
                if (this.target.overAllTargetText.trim() == '') return;
            } else {
                this.target.overAllTargetText = '';
                if (isNaN(this.target.overAllTarget) || this.target.overAllTarget.trim() == '') return;
            }
            let data = cloneDeep(this.target);
            data.overAllTarget = this.getExactAmt(this.target.overAllTarget);
            // data.planningTemplateId = this.campusTemplate.id;
            if (this.target.id > 0) {
                await this.$store
                    .dispatch(`planningtemplatemaintarget/UpdatePTMT`, data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.parentIndicatorItem.mainTargets.findIndex((x) => x.id == this.target.id);
                        this.parentIndicatorItem.mainTargets.splice(index, 1, data);
                        this.$bvModal.hide("create-target-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                await this.$store
                    .dispatch(`planningtemplatemaintarget/CreatePTMT`, data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.targetTemplateDeliveryUnits = [];
                        res.data.visible = false;
                        res.data.addDU = false;
                        res.data.mandatoryVisible = false;
                        res.data.mandatoryApis = cloneDeep(this.mandatoryApis);
                        res.data.loadDU = false;
                        res.data.selectedTarget = false;
                        res.data.zIndex = 0;
                        this.parentIndicatorItem.mainTargets.push(res.data);
                        this.$bvModal.hide("create-target-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        selectTarget(item, parent) {
            if (item.type.srcElement.checked) {
                parent.selectedTargets.push({ id: item.id });
            } else {
                let index = parent.selectedTargets.findIndex(x => x.id == item.id);
                parent.selectedTargets.splice(index, 1)
            }
        },
        unpostTarget(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to unpost this target?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, unpost it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch("planningtemplatedu/UnpostDUTemplate", { id: item.id, cycle: this.$store.state.data.cycle })
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.showToast("Successfully unposted!", "success");
                            item.status = null;
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            })
        },
        toggleMultipleSelection(parent) {
            parent.multipleSelection = !parent.multipleSelection;
            if (!parent.multipleSelection) parent.fetchedIndicatorItems.map(y => y.isSelected = false);
        },
        selectedIndicatorItems(parent) {
            return parent.fetchedIndicatorItems.filter(y => y.isSelected);
        },
        selectChangeAll(parent, ev) {
            parent.fetchedIndicatorItems.map(y => y.isSelected = ev.target.checked);
        },
        filteredPrexcItems(items) {
            let data = items;
            if (this.transferFilter && this.transferFilter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.transferFilter.toUpperCase());
                });
            }
            return data;
        },
        filteredIndicatorItems(items) {
            let data = items;
            if (this.transferFilter && this.transferFilter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.transferFilter.toUpperCase());
                });
            }
            return data;
        },
        async postMainTarget(row) {
            let duIds = [];
            row.dus.map(item => {
                if (!item.status) {
                    duIds.push({ id: item.deliveryUnitId });
                }
            })
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this in this cycle " + this.$store.state.data.cycle + " ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "planningtemplatedu/PostDUTemplate",
                            {
                                cycle: this.$store.state.data.cycle,
                                planningMainTargetId: row.mainTargetId,
                                campusId: row.campusId,
                                duIds: duIds,
                            }
                        )
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            row.dus.map(item => {
                                if (!item.status) {
                                    item.status = 'Posted';
                                }
                            })
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be posted!", "error");
                        });
                }
            });
        },
        saveAnnualTarget(form, parent) {
            let data = cloneDeep(form);
            data.indicatorItemId = parent.id;
            data.campusId = this.$store.state.data.selectedCampus.id;
            if (form.id > 0) {
                this.$store
                    .dispatch("kpiannualtarget/UpdateKPIAnnualTarget", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = parent.annualTargets.findIndex(i => i.id == data.id);
                        let idx = parent.kpiAnnualTargets.findIndex(i => i.id == data.id);
                        parent.annualTargets.splice(index, 1, data);
                        if (idx > -1) parent.kpiAnnualTargets.splice(idx, 1, data);
                        this.showToast('Successfully updated!', 'success')
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store
                    .dispatch("kpiannualtarget/CreateKPIAnnualTarget", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        data.id = res.data.id;
                        parent.annualTargets.push(data);
                        if (data.cycle == this.$store.state.data.cycle) {
                            parent.kpiAnnualTargets.push(data);
                        }
                        this.showToast('Successfully created!', 'success')
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        removeAnnualTarget(row, parent) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("kpiannualtarget/DeleteKPIAnnualTarget", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            let index = parent.annualTargets.findIndex(i => i.id == row.id);
                            let idx = parent.kpiAnnualTargets.findIndex(i => i.id == row.id);
                            parent.annualTargets.splice(index, 1);
                            if (idx > -1) parent.kpiAnnualTargets.splice(index, 1);
                            this.showToast('Successfully removed!', 'success')
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            })
        },
        filteredTab(arr) {
            let data = arr;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
        saveBaseline(data) {
            if (data.baselineId) {
                this.$store
                    .dispatch("kpibaseline/UpdateKpiBaseLine", {
                        id: data.baselineId,
                        baseline: data.baselineCopy,
                        campusId: this.$store.state.data.selectedCampus.id,
                        indicatorItemId: data.id
                    })
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        data.baseline = data.baselineCopy;
                        data.editBaseline = false;
                        this.showToast('Successfully updated!', 'success')
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store
                    .dispatch("kpibaseline/CreateKpiBaseLine", {
                        baseline: data.baselineCopy,
                        campusId: this.$store.state.data.selectedCampus.id,
                        indicatorItemId: data.id
                    })
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        data.baselineId = res.data.id;
                        data.baseline = data.baselineCopy;
                        data.editBaseline = false;
                        this.showToast('Successfully created!', 'success')
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        multipleSelectTargets(row) {
            row.singleSelection = !row.singleSelection;
            row.selectedTargets = [];
            row.mainTargets.map(item => item.selectedTarget = false);
        },
        selectAllMainTarget(row, checkbox) {
            row.mainTargets.forEach(item => {
                item.selectedTarget = checkbox.srcElement.checked
            });
            row.selectedTargets = checkbox.srcElement.checked ? cloneDeep(row.mainTargets) : []
        },
        transferMainTarget(selected, row, parent) {
            this.selectedKPI = {
                id: row.id
            };
            this.selectedIndicator = parent;
            this.selectedTargets = cloneDeep(selected);
            this.transferObject = 'target';
            this.modalTitle = 'Transfer Target to Another KPI';
            this.$bvModal.show('transfer-item-modal');
        },
        getPa() {
            this.$refs.prexcModal.getData();
            this.$bvModal.show('program-area-modal');
        },
        dropProgramArea(data) {
            this.prexc = data;
            this.form.prexcId = data.id;
        },
        downloadTemplate() {
            const s2ab = (s) => {
                var buf = new ArrayBuffer(s.length);
                var view = new Uint8Array(buf);
                for (var i = 0; i < s.length; i++) {
                    view[i] = s.charCodeAt(i) & 0xff;
                }
                return buf;
            };
            this.$swal.fire({
                title: "Are you sure?",
                text: "You want to download the template?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, download it!",
            }).then((result) => {
                if (result.value) {
                    let wb = XLSX.utils.book_new();
                    wb.Props = {
                        Title: "KPI Template",
                        Subject: "For Uploading",
                        Author: "GIAMS Website",
                        CreatedDate: new Date(),
                    };
                    wb.SheetNames.push("KPI_Data");
                    let ws_data = [[
                        "KPI_Name",
                        "KPI_Type",
                        "Points",
                        "Overall_Target",
                        "Year_to_be_complied",
                        "KPI_Code",
                        "KPI_Classification",
                        "Is_Percentage (TRUE/FALSE)",
                        "Is_Recurring (TRUE/FALSE)",
                        "Allow_DU_to_add_tag (TRUE/FALSE)",
                        "Show in PRE (TRUE/FALSE)"
                    ]];
                    let ws = XLSX.utils.aoa_to_sheet(ws_data);

                    // Set column widths
                    ws['!cols'] = [
                        { wch: 30 }, // KPI_Name
                        { wch: 15 }, // KPI_Type
                        { wch: 10 }, // Points
                        { wch: 25 }, // Overall_Target
                        { wch: 20 }, // Year_to_be_complied
                        { wch: 15 }, // KPI_Code
                        { wch: 25 }, // KPI_Classification
                        { wch: 30 }, // Is_Percentage
                        { wch: 30 }, // Is_Recurring
                        { wch: 40 }, // Allow_DU_to_add_tag
                        { wch: 30 }  // Show in PRE
                    ];

                    wb.Sheets["KPI_Data"] = ws;

                    // Create dropdown options sheet
                    wb.SheetNames.push("DropdownOptions");
                    let dropdown_data = [
                        ["KPI_Types", "KPI_Classifications", "Boolean_Options"],
                        ["Output", "Core Function", "TRUE"],
                        ["Outcome", "External Project", "FALSE"],
                        ["Impact", "Intervening Task", ""],
                        ["", "Mandatory Support Functions", ""],
                        ["", "Strategic Priority", ""]
                    ];
                    let dropdown_ws = XLSX.utils.aoa_to_sheet(dropdown_data);
                    wb.Sheets["DropdownOptions"] = dropdown_ws;

                    // Create instructions sheet
                    wb.SheetNames.push("Instructions");
                    let instructions_data = [
                        ["INSTRUCTIONS FOR FILLING THE KPI TEMPLATE"],
                        [""],
                        ["1. KPI_Name: Enter the full name/description of the KPI"],
                        ["2. KPI_Type: Select from dropdown - Output, Outcome, or Impact"],
                        ["3. Points: Enter numeric value for points"],
                        ["4. Overall_Target/Standard: Enter the target value"],
                        ["5. Year_to_be_complied: Enter the year (e.g., 2024)"],
                        ["6. KPI_Code: Enter unique code for the KPI"],
                        ["7. KPI_Classification: Enter classification. Select from dropdown - Core Function, External Project, Intervening Task, Mandatory Support Functions and Strategic Priority"],
                        ["8. Is_Percentage: Select TRUE or FALSE only"],
                        ["9. Is_Recurring: Select TRUE or FALSE only"],
                        ["10. Allow_DU_to_add_tag: Select TRUE or FALSE only"],
                        ["11. Show in PRE: Select TRUE or FALSE only"],
                        [""],
                        ["DROPDOWN OPTIONS:"],
                        ["- KPI_Type: Output, Outcome, Impact"],
                        ["- Boolean fields: TRUE, FALSE"],
                        [""],
                        ["NOTE: To create dropdowns in Excel:"],
                        ["1. Select the cell(s) you want to add dropdown to"],
                        ["2. Go to Data > Data Validation"],
                        ["3. Select 'List' from Allow dropdown"],
                        ["4. For KPI_Type: Enter 'Output,Outcome,Impact'"],
                        ["5. For Boolean fields: Enter 'TRUE,FALSE'"],
                        ["6. Click OK"]
                    ];
                    let instructions_ws = XLSX.utils.aoa_to_sheet(instructions_data);
                    instructions_ws['!cols'] = [{ wch: 60 }];
                    wb.Sheets["Instructions"] = instructions_ws;

                    let wbout = XLSX.write(wb, {
                        bookType: "xlsx",
                        type: "binary",
                    });
                    saveAs(
                        new Blob([s2ab(wbout)], {
                            type: "application/octet-stream",
                        }),
                        "KPI_Template.xlsx"
                    );
                }
            });
        }
    },
};
</script>

<template>
    <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)"
        @changeCampus="changeData($store.state.data.cycle, $event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal id="indicator-item-modal" :title="modalTitle" size="lg" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <form @submit.prevent="onCreateIndicatorItem" class="needs-validation" ref="fcForm">
                <div class="row">
                    <div class="col-6">
                        <div class="mb-3">
                            <label for="indicatorItemName">KPI Name </label>
                            <textarea id="indicatorItemName" rows="5" v-model="indicatorForm.indicatorItemName"
                                placeholder="Enter KPI Name..." class="form-control" :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.indicatorForm.indicatorItemName
                                            .$error,
                                }"></textarea>
                            <div v-if="
                                submitted &&
                                $v.indicatorForm.indicatorItemName.$error
                            " class="invalid-feedback">
                                <span v-if="
                                    !$v.indicatorForm.indicatorItemName
                                        .required
                                ">This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="type">KPI Type </label>
                                    <b-form-select class="form-select" v-model="indicatorForm.type" size="sm"
                                        :options="indicatorTypes" :class="{
                                            'is-invalid':
                                                submitted &&
                                                $v.indicatorForm.type.$error,
                                        }"></b-form-select>
                                    <div v-if="submitted && $v.indicatorForm.type.$error" class="invalid-feedback">
                                        <span v-if="!$v.indicatorForm.type.required">This value is required.</span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="points">Points </label>
                                    <masked-input autocomplete="off" id="points" type="text"
                                        v-model="indicatorForm.points" placeholder="Enter Points..."
                                        class="form-control" :class="{
                                            'is-invalid':
                                                submitted &&
                                                $v.indicatorForm.points.$error,
                                        }" :mask="currencyMask"></masked-input>
                                    <div v-if="
                                        submitted && $v.indicatorForm.points.$error
                                    " class="invalid-feedback">
                                        <span v-if="!$v.indicatorForm.points.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="overAllTarget">Overall Target/Standard </label>
                                    <masked-input autocomplete="off" id="overAllTarget" type="text"
                                        v-model="indicatorForm.overAllTarget" placeholder="Enter Overall Target..."
                                        class="form-control" :class="{
                                            'is-invalid':
                                                submitted &&
                                                $v.indicatorForm.overAllTarget.$error,
                                        }" :mask="currencyMask" v-if="!indicatorForm.allowText"></masked-input>
                                    <input v-model="indicatorForm.overAllTargetText" type="text" class="form-control"
                                        placeholder="Enter Overall Target..."
                                        :class="{ 'is-invalid': submitted && $v.indicatorForm.overAllTarget.$error }"
                                        v-else />
                                    <div v-if="
                                        submitted && $v.indicatorForm.overAllTarget.$error
                                    " class="invalid-feedback">
                                        <span v-if="!$v.indicatorForm.overAllTarget.required">This value is
                                            required.</span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="yearToBeComplied">Year to be complied
                                    </label>
                                    <select class="form-select" v-model="indicatorForm.yearToBeComplied"
                                        :class="{ 'is-invalid': submitted && $v.indicatorForm.yearToBeComplied.$error }">
                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                    </select>
                                    <!-- <date-picker
                                        v-model="indicatorForm.yearToBeComplied"
                                        type="year"
                                        lang="en"
                                        placeholder="Enter Year..."
                                        editable="true"
                                        clearable="true"
                                        :class="{ 'is-invalid': submitted && $v.indicatorForm.yearToBeComplied.$error }"
                                    ></date-picker> -->
                                    <div v-if="submitted && $v.indicatorForm.yearToBeComplied.$error"
                                        class="invalid-feedback">
                                        <span v-if="
                                            !$v.indicatorForm.yearToBeComplied
                                                .required
                                        ">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="mb-3">
                            <label for="indicatorItemClassificationId">KPI Code
                            </label>
                            <input autocomplete="off" type="text" placeholder="Enter KPI Code..." class="form-control"
                                v-model="indicatorForm.code" />
                        </div>
                        <div class="mb-3">
                            <label for="kpiGroupId">KPI Group
                            </label>
                            <select class="form-select" v-model="indicatorForm.indicatorItemGroupId">
                                <option value="" disabled>Select KPI Group</option>
                                <option value="0">No Group</option>
                                <option v-for="group in kpiGroups" :key="group.id" :value="group.id">{{ group.groupName
                                }}</option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="indicatorItemClassificationId">KPI Classification
                            </label>
                            <b-input-group>
                                <template #append>
                                    <b-button @click="getApiClass" variant="outline-info">
                                        <i class="mdi  mdi-clipboard-text-search-outline"></i>
                                    </b-button>
                                </template>
                                <input autocomplete="off" type="text" disabled
                                    placeholder="Search KPI Classification..." class="form-control"
                                    :class="{ 'is-invalid': submitted && $v.indicatorForm.indicatorItemClassificationId.$error }"
                                    v-model="indicatorItemClassification.classification" />
                            </b-input-group>
                            <div v-if="
                                submitted &&
                                $v.indicatorForm
                                    .indicatorItemClassificationId.$error
                            " class="invalid-feedback">
                                <span v-if="
                                    !$v.indicatorForm
                                        .indicatorItemClassificationId
                                        .required
                                ">This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3" v-if="indicatorForm.id > 0">
                            <label for="finalRemarks">Final Remarks </label>
                            <textarea autocomplete="off" id="finalRemarks" rows="2" v-model="indicatorForm.finalRemarks"
                                placeholder="Enter Final Remarks..." class="form-control"></textarea>
                        </div>
                        <div class="d-flex mb-1">
                            <div class="me-3">
                                <input class="form-check-input" type="checkbox" id="isPercentage"
                                    v-model="indicatorForm.isPercentage" />&nbsp;&nbsp;
                                <label class="form-check-label" for="isPercentage">Percentage</label>
                            </div>
                            <div class="me-3" v-if="indicatorForm.id > 0">
                                <input class="form-check-input" type="checkbox" id="isCompleted"
                                    v-model="indicatorForm.isCompleted" />&nbsp;&nbsp;
                                <label class="form-check-label" for="isCompleted">Completed</label>
                            </div>
                            <div>
                                <input class="form-check-input" type="checkbox" id="isRecurring"
                                    v-model="indicatorForm.isRecurring" />&nbsp;&nbsp;
                                <label class="form-check-label" for="isRecurring">Recurring</label>
                            </div>
                        </div>
                        <div>
                            <input class="form-check-input" type="checkbox" id="allowDeliveryUnitToAddTag"
                                v-model="indicatorForm.allowDeliveryUnitToAddTag" />&nbsp;&nbsp;
                            <label class="form-check-label me-3" for="allowDeliveryUnitToAddTag">Allow DU to Add
                                Tag</label>
                            <input class="form-check-input" type="checkbox" id="showInPRE"
                                v-model="indicatorForm.showInPRE" />&nbsp;&nbsp;
                            <label class="form-check-label me-3" for="showInPRE">Show in PRE</label>
                            <input class="form-check-input" type="checkbox" id="allowText"
                                v-model="indicatorForm.allowText" />&nbsp;&nbsp;
                            <label class="form-check-label" for="allowText">Allow Text</label>
                        </div>
                        <div>
                            <input class="form-check-input" type="checkbox" id="showInAdminDashboard"
                                v-model="indicatorForm.showInAdminDashboard" />&nbsp;&nbsp;
                            <label class="form-check-label" for="showInAdminDashboard">Files can be viewed</label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-link" @click="$bvModal.hide('indicator-item-modal')">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal id="transfer-item-modal" :title="modalTitle" size="lg" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <div class="mb-3">
                <input type="text" class="form-control" placeholder="Search Indicator..." v-model="transferFilter">
            </div>
            <div class="mb-2">
                <template v-for="y in filteredTransferTable">
                    <div class="d-flex" :key="`A-${y.id}`">
                        <a href="javascript:void(0);" class="d-flex align-items-center"
                            @click="y.rotateChev = !y.rotateChev">
                            <div class="ms-1 d-flex align-items-center border border-warning text-yellow w-15px">
                                <i :class="[y.rotateChev ? `bx bx-minus` : `bx bx-plus`]"></i>
                            </div>
                            <span class="ms-1 font-size-16px font-weight-bold text-white" style="line-height-1">{{
                                y.prexcClass }}</span>
                        </a>
                    </div>
                    <div v-if="y.rotateChev" class="line-height-1" :key="`B-${y.id}`">
                        <template v-for="(z, zIndex) in filteredPrexc(y.items, 'transfer')">
                            <div class="d-flex" :key="`IA-${z.id}`">
                                <div class="w-12px"
                                    :class="{ 'border-right-light': zIndex != filteredPrexc(y.items, 'transfer').length - 1 }">
                                    <div class="h-50 border-right-light"
                                        v-if="zIndex == filteredPrexc(y.items, 'transfer').length - 1"></div>
                                </div>
                                <div class="w-20px">
                                    <div class="h-50 border-bottom-light"></div>
                                </div>
                                <div class="py-1">
                                    <div class="d-flex align-items-center">
                                        <a class="ms-1 d-flex align-items-center border border-warning text-yellow h-16px"
                                            href="javascript:void(0);" @click="z.rotateChev = !z.rotateChev">
                                            <i :class="[z.rotateChev ? `bx bx-minus` : `bx bx-plus`]"></i>
                                        </a>
                                        <div>
                                            <p class="ms-1 font-size-15px mb-0 text-white" style="font-weight:300;">
                                                {{ z.prexc }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="w-11px"></div>
                                        <div class="w-40px" :class="{ 'border-left-light': z.rotateChev }"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="z.rotateChev" :key="`IB-${z.id}`">
                                <template v-for="(w, wIndex) in filteredPrexcItems(z.items)">
                                    <div class="d-flex" :key="w.id">
                                        <div class="w-12px"
                                            :class="{ 'border-right-light': zIndex != filteredPrexc(y.items, 'transfer').length - 1 }">
                                        </div>
                                        <div class="w-20px"></div>
                                        <div class="w-12px" :class="{
                                            'border-right-light': (wIndex != filteredPrexcItems(z.items).length - 1 && w.rotateChev),
                                        }">
                                            <div class="h-50 border-right-light"
                                                v-if="wIndex == filteredPrexcItems(z.items).length - 1 || !w.rotateChev">
                                            </div>
                                        </div>
                                        <div class="w-12px ">
                                            <div class="h-50 border-bottom-light"></div>
                                        </div>
                                        <div class="w-18px">
                                            <div class="h-50 border-bottom-light"></div>
                                        </div>
                                        <div class="font-size-13px py-1 ms-1" style="width:calc(100% - 120px)">
                                            <div class="d-flex align-items-center">
                                                <a class="ms-1 d-flex align-items-center border border-warning text-yellow h-16px"
                                                    href="javascript:void(0);" v-if="transferObject == 'target'"
                                                    @click="w.rotateChev = !w.rotateChev">
                                                    <i :class="[w.rotateChev ? `bx bx-minus` : `bx bx-plus`]"></i>
                                                </a>
                                                <span class="ms-1 font-size-14px text-white" style="line-height-1">{{
                                                    w.indicatorName }}</span>
                                                <small
                                                    v-if="transferObject == 'kpi' && selectedIndicator && w.id != selectedIndicator.id">
                                                    <a href="javascript:void(0);" class="text-green hover-underline"
                                                        @click="transferNow(w, 'kpi')">(Transfer Here)
                                                    </a>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="w.rotateChev && transferObject == 'target'" :key="`WB-${w.id}`">
                                        <template v-for="(a, aIndex) in filteredIndicatorItems(w.indicatorItems)">
                                            <div class="d-flex" :key="a.id">
                                                <div class="w-12px"
                                                    :class="{ 'border-right-light': zIndex != filteredPrexc(y.items, 'transfer').length - 1 }">
                                                </div>
                                                <div class="w-20px"></div>
                                                <div class="w-12px" :class="{
                                                    'border-right-light': (wIndex != filteredPrexcItems(z.items).length - 1 && w.rotateChev),
                                                }">
                                                    <div class="h-50 border-right-light"
                                                        v-if="wIndex == filteredPrexcItems(z.items).length - 1 && !w.rotateChev">
                                                    </div>
                                                </div>
                                                <div class="w-35px"></div>
                                                <div class="w-12px"
                                                    :class="{ 'border-right-light': aIndex != filteredIndicatorItems(w.indicatorItems).length - 1 }">
                                                    <div class="h-50 border-right-light"
                                                        v-if="aIndex == filteredIndicatorItems(w.indicatorItems).length - 1">
                                                    </div>
                                                </div>
                                                <div class="w-12px ">
                                                    <div class="h-50 border-bottom-light"></div>
                                                </div>
                                                <div class="w-18px">
                                                    <div class="h-50 border-bottom-light"></div>
                                                </div>
                                                <div class="font-size-13px py-1 ms-1" style="width:calc(100% - 190px)">
                                                    {{ a.indicatorItemName }}
                                                    <small
                                                        v-if="transferObject == 'target' && selectedKPI && a.id != selectedKPI.id">
                                                        <a href="javascript:void(0);" class="text-green hover-underline"
                                                            @click="transferNow(a, 'target')">(Transfer Here)
                                                        </a>
                                                    </small>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-link" @click="$bvModal.hide('transfer-item-modal')">
                    Cancel
                </button>
            </div>
        </b-modal>
        <b-modal id="modal-standard" :title="modalTitle" size="md" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
                <div class="mb-3" v-if="addOutside">
                    <label for="prexcId">Program Area</label>
                    <!-- <multiselect
                        v-model="prexc"
                        :options="prexcs"
                        label="prexcName"
                        @select="selectPrexc"
                        track-by="id"
                        value="id"
                        deselect-label=""
                        select-label=""
                        :allow-empty="false"
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.form.prexcId.$error,
                        }"
                    /> -->
                    <b-input-group>
                        <template #append>
                            <b-button @click="getPa" variant="outline-info">
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </template>
                        <div class="form-control">
                            <span class="text-muted" v-if="!prexc">Search Program Area...</span>
                            <template v-else>
                                <div>
                                    <h6 class="mb-0">{{ prexc.prexcClassification.classification }}</h6>
                                    <div class="d-flex mt-1">
                                        <div class="h-auto" style="width:20px;">
                                            <div class="h-50 border-left-light border-bottom-light"></div>
                                        </div>
                                        <div class="font-weight-bold text-yellow font-size-12 ms-1 line-height-1">
                                            {{ prexc.prexcName }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </b-input-group>
                    <div v-if="
                        submitted &&
                        $v.form.prexcId.$error
                    " class="invalid-feedback">
                        <span v-if="!$v.form.prexcId.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="indicatorName">Programs and Projects (PAPs)
                    </label>
                    <textarea id="indicatorName" rows="5" type="text" v-model="form.indicatorName"
                        placeholder="Enter Programs and Projects (PAPs)..." class="form-control" :class="{
                            'is-invalid':
                                submitted &&
                                $v.form.indicatorName
                                    .$error,
                        }"></textarea>
                    <div v-if="
                        submitted &&
                        $v.form.indicatorName.$error
                    " class="invalid-feedback">
                        <span v-if="
                            !$v.form.indicatorName
                                .required
                        ">This value is required.</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-link" @click="$bvModal.hide('modal-standard')">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal id="create-target-modal" :title="modalTitle" size="md" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <form @submit.prevent="onCreateTarget" autocomplete="off" class="needs-validation" ref="targetForm">

                <div class="mb-3">
                    <label for="target-description">Target Description</label>
                    <textarea id="target-description" class="form-control" rows="5" v-model="target.description"
                        placeholder="Enter Target Description" :class="{
                            'border-danger':
                                !target.description &&
                                submitted,
                        }"></textarea>
                </div>
                <div>
                    <label for="overall-target">Overall Target</label>
                    <input v-model="target.overAllTargetText" type="text" class="form-control w-100"
                        placeholder="Overall Target"
                        :class="{ 'border-danger': !target.overAllTargetText && submitted }"
                        v-if="parentIndicatorItem && parentIndicatorItem.allowText" />
                    <masked-input id="overall-target" type="text" class="form-control w-100"
                        placeholder="Overall Target" v-model="target.overAllTarget" :mask="currencyMask" :class="{
                            'border-danger':
                                !target.overAllTarget &&
                                submitted,
                        }" v-else></masked-input>
                </div>
                <div class="mt-3 d-flex align-items-center">
                    <!-- <div class="d-flex align-items-center me-2">
                        <switches
                            v-model="target.isPercentage"
                            id="isPercentage"
                        ></switches>
                        <label for="isPercentage" class="mx-2">
                            <span v-if="target.isPercentage"
                                >Percentage</span
                            >
                            <del v-else>Percentage</del>
                        </label>
                    </div> -->
                    <div class="d-flex align-items-center me-3">
                        <switches v-model="target.allowAdd" id="isPercentage" color="success"></switches>
                        <label for="isPercentage" class="mx-2">
                            <span v-if="target.allowAdd">Allow Add</span>
                            <del v-else>Allow Add</del>
                        </label>
                    </div>
                    <div class="form-check form-checkbox-outline form-check-success mb-2">
                        <input type="checkbox" id="isLocked" class="form-check-input" v-model="target.isLocked" />
                        <label for="isLocked" class="form-check-label"><i class="bx bx-lock"></i> Lock this
                            Target</label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-link" @click="$bvModal.hide('create-target-modal')">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal id="api-modal" :title="modalTitle" size="xl" title-class="font-18" hide-footer no-close-on-backdrop>
            <ul>
                <li>
                    <b class="font-size-14">Main Target:</b> <span class="font-size-16"><u>{{ selectedDU &&
                        selectedDU.description }}</u></span>
                </li>
                <li>
                    <b class="font-size-14">Delivery Unit:</b> <span class="text-warning font-size-16">{{ selectedDU &&
                        selectedDU.deliveryUnit.name }}</span>
                </li>
            </ul>
            <table class="table table-bordered ">
                <thead>
                    <tr>
                        <th width="40%">
                            <div class="d-flex">
                                API Name/Description
                                <button type="button" class="btn btn-warning btn-sm px-2 py-0 ms-1" v-if="!viewingApi"
                                    @click="addMoreApi">
                                    <template v-if="!addApi">
                                        <i class="bx bx-plus"></i>Add More
                                    </template>
                                    <template v-else>
                                        <i class="bx bx-x"></i>Cancel
                                    </template>
                                </button>
                            </div>
                        </th>
                        <th :width="viewingApi && '20%'">API Type</th>
                        <th v-if="!viewingApi" class="text-center" :width="!addApi ? '90px' : '10%'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!apiLoading && apiData.length == 0 && !addApi">
                        <td :colspan="!viewingApi ? 3 : 2" class="text-center">No Data Found</td>
                    </tr>
                    <template v-if="!apiLoading && apiData.length > 0">
                        <template v-for="x in apiData">
                            <tr :key="`parent-not-edit-${x.id}`" v-if="!x.editMode">
                                <td>
                                    <div>{{ x.name }}</div>
                                    <small>{{ x.description }}</small>
                                </td>
                                <td>
                                    {{ x.apiType.type }}
                                </td>
                                <td class="align-middle" v-if="!viewingApi">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <button type="button" title="Edit" class="btn btn-link p-0 font-size-16 me-1"
                                            @click="updateApi(x)">
                                            <i class="bx bx-edit"></i>
                                        </button>
                                        <button type="button" title="Delete" class="btn btn-link p-0 font-size-16"
                                            @click="deleteApi(x)">
                                            <i class=" bx bx-trash text-danger"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr :key="`parent-edit-${x.id}`" v-else>
                                <td>
                                    <input type="text" class="form-control mb-3" v-model="api.name"
                                        placeholder="Enter API Name"
                                        :class="{ 'is-invalid': submitted && $v.api.name.$error }" />
                                    <textarea rows="3" class="form-control" v-model="api.description"
                                        placeholder="Enter API Description"
                                        :class="{ 'is-invalid': submitted && $v.api.description.$error }" />
                                </td>
                                <td>
                                    <input type="text" class="form-control cursor-pointer" v-model="api.apiType.type"
                                        placeholder="Click to Select Api Type" readonly @click="showApiType"
                                        :class="{ 'is-invalid': submitted && $v.api.apiTypeId.$error }" />
                                </td>
                                <td class="text-center" v-if="!viewingApi">
                                    <button type="button" class="btn btn-success" @click="saveApi">
                                        <i class="bx bx-save"></i> Save
                                    </button>
                                    <button type="button" class="btn btn-clear" @click="x.editMode = false">
                                        <i class="bx bx-x"></i> Cancel
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <template v-if="addApi">
                        <tr>
                            <td>
                                <input type="text" class="form-control mb-3" v-model="api.name"
                                    placeholder="Enter API Name" :class="{
                                        'is-invalid':
                                            submitted && $v.api.name.$error,
                                    }" />
                                <textarea rows="3" class="form-control" v-model="api.description"
                                    placeholder="Enter API Description" :class="{
                                        'is-invalid':
                                            submitted && $v.api.description.$error,
                                    }" />
                            </td>
                            <td>
                                <input type="text" class="form-control cursor-pointer" v-model="api.apiType.type"
                                    placeholder="Click to Select Api Type" readonly @click="showApiType" :class="{
                                        'is-invalid':
                                            submitted && $v.api.apiTypeId.$error,
                                    }" />
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-success" @click="saveApi">
                                    <i class="bx bx-save"></i> Save
                                </button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </b-modal>
        <div>
            <div class="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-2
                ">
                <div>
                    <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                            <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search..."
                                class="form-control"></b-form-input>
                            <b-form-select class="form-select ms-1" v-model="perPage" :options="pageOptions"
                                style="width:100px;"></b-form-select>
                            <b-dropdown menu-class="dropdown-menu-end" variant="black" toggle-class="p-0">
                                <template v-slot:button-content>
                                    <a href="javascript:void(0);" class="
                                            font-size-20
                                            mx-2
                                            text-dark
                                        "><i class="bx bx-slider"></i></a>
                                </template>
                                <b-dropdown-item @click="filterBy = 'all'">
                                    <div class="d-flex">
                                        <div style="width: 20px">
                                            <i class="bx bx-check" v-if="
                                                filterBy ===
                                                'all'
                                            "></i>
                                        </div>
                                        All
                                    </div>
                                </b-dropdown-item>
                                <b-dropdown-item v-for="x in itemClassifications" :key="x.id" @click="
                                    filterBy = x.classification
                                    ">
                                    <div class="d-flex">
                                        <div style="width: 20px">
                                            <i class="bx bx-check" v-if="
                                                filterBy ===
                                                x.classification
                                            "></i>
                                        </div>
                                        {{ x.classification }}
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </label>
                    </div>
                </div>
                <div class="d-flex">
                    <button class="btn btn-success me-1" title="Download Template for Excel Uploading"
                        @click="downloadTemplate">
                        <i class="bx bx-import fs-6"></i> Template
                    </button>
                    <LibPreReportBtn :id="1" @printLIB="printLIB" @printPRE="printPRE" @printBar1PRO="printBar1PRO"
                        @printVariance="printVariance" />
                    <button type="button" @click="addFC()" class="
                            btn btn-md btn-info
                            d-flex
                            align-items-center
                        ">
                        <i class="bx bx-plus fs-6"></i>Create New
                    </button>
                </div>
            </div>
            <div class="mb-2">
                <template v-if="tableBusy">
                    <template v-for="n in 3">
                        <div :key="n" class="mb-2">
                            <div class="d-flex align-items-center mb-1">
                                <b-skeleton width="10px" height="10px" class="me-2"></b-skeleton>
                                <b-skeleton width="250px" height="25px"></b-skeleton>
                            </div>
                            <div v-for="a in 3" :key="a" class="mb-1">
                                <b-skeleton width="98%" height="50px" class="ms-5"></b-skeleton>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-for="w in filteredTable">
                    <div :key="w.id">
                        <a href="javascript:void(0);" class="d-flex align-items-center my-2"
                            @click="w.rotateChevy = !w.rotateChevy">
                            <div class="ms-1 d-flex align-items-center border border-warning text-yellow w-15px me-1">
                                <i :class="[w.rotateChevy ? `bx bx-minus` : `bx bx-plus`]"></i>
                            </div>
                            <h4 class="mb-0 text-white">{{ w.prexcClass }}</h4>
                        </a>
                        <div class="ms-4" v-if="w.rotateChevy">
                            <template v-for="(x, xIndex) in filteredPrexc(w.items)">
                                <b-card :key="x.id" no-body class="mb-1 shadow-none"
                                    :style="{ 'zIndex': filteredPrexc(w.items).length - xIndex + 10 }">
                                    <b-card-header header-tag="header" role="tab" class="border">
                                        <div class="
                                                d-flex
                                                justify-content-between
                                                align-items-center
                                            ">
                                            <div class="d-flex align-items-start">
                                                <div style="width: 5px;height:5px;"
                                                    class="bg-warning bg-gradient text-center me-2 mt-1"></div>
                                                <div class="text-muted">
                                                    <h5 class="mb-0 line-height-1 hover-underline cursor-pointer"
                                                        @click="showGrpDtls(x)">
                                                        {{ x.prexc }}
                                                    </h5>
                                                    <!-- <div class="line-height-1">
                                                        <small>{{x.prexc.prexcClassification.classification}}</small>
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div>
                                                <a href="javascript:void(0)" @click="showGrpDtls(x)">
                                                    <i class="bx  font-size-24"
                                                        :class="[x.rotateChevy ? 'bx-chevron-down' : 'bx-chevron-right']"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </b-card-header>
                                    <b-collapse :visible="x.rotateChevy" :accordion="`prexc-${x.id}`" role="tabpanel">
                                        <b-card-body class="border">
                                            <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-sm-2"
                                                content-class="pt-0 px-2 text-muted border-start">
                                                <b-tab title-item-class="mb-2" v-for="y in filteredTab(x.items)"
                                                    :key="y.id" @click="getIndicatorItems(y)"
                                                    title-link-class="ps-3 pe-2">
                                                    <template v-slot:title>
                                                        <div class="d-flex w-100 align-items-center justify-content-between"
                                                            @drop="onDropZone($event, y)" @dragenter.prevent
                                                            @dragover.prevent>
                                                            <span>{{ y.indicatorName }}</span>
                                                            <i class="bx bx-dots-vertical-rounded ms-3"
                                                                :id="`popover-target-${x.id}-${y.id}`"></i>
                                                            <b-popover :target="`popover-target-${x.id}-${y.id}`"
                                                                id="menu" triggers="hover blur" placement="leftbottom"
                                                                custom-class="p-0 p-custom-class"
                                                                :show.sync="y.showOpts">
                                                                <b-list-group class="w-100 fit">
                                                                    <b-list-group-item button action
                                                                        @click="updateOutcome(y, x)">
                                                                        <i
                                                                            class="bx bx-edit align-middle me-2 font-size-16"></i>
                                                                        <span class="align-middle">Edit</span>
                                                                    </b-list-group-item>

                                                                    <b-list-group-item button action
                                                                        @click="removeOutcome(y, x)">
                                                                        <i
                                                                            class="bx bx-trash align-middle me-2 font-size-16 text-danger"></i>
                                                                        <span
                                                                            class="align-middle text-danger">Delete</span>
                                                                    </b-list-group-item>
                                                                </b-list-group>
                                                            </b-popover>
                                                        </div>
                                                    </template>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <h5 class="mb-0">List of KPI's</h5>
                                                            <div>
                                                                <div class="d-flex align-items-center"
                                                                    v-if="!y.indicatorItemLoading">
                                                                    <div class="
                                                                            form-check
                                                                            form-checkbox-outline
                                                                            form-check-success
                                                                            mb-0
                                                                            me-1
                                                                        " v-if="y.multipleSelection">
                                                                        <input type="checkbox" :id="`selecAll${y.id}`"
                                                                            class="form-check-input"
                                                                            @change="selectChangeAll(y, $event)"
                                                                            :checked="selectedIndicatorItems(y).length == y.fetchedIndicatorItems.length ? 'checked' : null" />
                                                                        <label :for="`selecAll${y.id}`"
                                                                            class="form-check-label">
                                                                            Select All |
                                                                        </label>
                                                                    </div>
                                                                    <small class="me-1" v-if="!y.updateSequence">
                                                                        <a href="javascript:void(0);"
                                                                            :class="[y.multipleSelection ? 'text-warning' : 'text-green']"
                                                                            @click="toggleMultipleSelection(y)">
                                                                            {{ y.multipleSelection ? "Cancel Selection"
                                                                                : "Select Items" }}
                                                                        </a>
                                                                        |
                                                                        <small v-if="y.multipleSelection"
                                                                            class="glow ms-1">You can start selecting
                                                                            indicator
                                                                            items.</small>
                                                                    </small>
                                                                    <template v-if="!y.multipleSelection">
                                                                        <small class="me-1">
                                                                            <a href="javascript:void(0);"
                                                                                @click="toggleSequence(y)">
                                                                                {{
                                                                                    y.updateSequence ?
                                                                                        "Cancel Updating Sequence" :
                                                                                        "Update Sequence"
                                                                                }}
                                                                            </a>
                                                                        </small>
                                                                        <div v-if="y.updateSequence">
                                                                            |
                                                                        </div>
                                                                        <small v-if="y.updateSequence"
                                                                            class="glow ms-1">You can start dragging the
                                                                            cards.</small>
                                                                    </template>
                                                                </div>
                                                                <div v-else class="mt-1">
                                                                    <b-skeleton width="100px"
                                                                        height="10px"></b-skeleton>
                                                                </div>
                                                                <div class="col-md-6 text-right">

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div v-if="!y.indicatorItemLoading" class="d-flex">
                                                                <input type="text"
                                                                    class="form-control form-control-sm me-1"
                                                                    placeholder="Search KPI..."
                                                                    v-model="y.searchFilter">
                                                                <b-button @click="uploadIndicatorItem(y)"
                                                                    variant="success" size="sm"
                                                                    class="text-nowrap me-1">
                                                                    <i class="bx bx-upload"></i>
                                                                    Upload KPI
                                                                </b-button>
                                                                <b-button @click="addIndicatorItem(y)" variant="primary"
                                                                    size="sm" class="text-nowrap">
                                                                    <i class="bx bx-plus"></i>
                                                                    Add KPI
                                                                </b-button>
                                                                <b-button
                                                                    @click="transferIndicatorItems(selectedIndicatorItems(y), y)"
                                                                    variant="success" size="sm" class="ms-1 text-nowrap"
                                                                    v-if="selectedIndicatorItems(y).length">
                                                                    <i class="bx bx-transfer"></i>
                                                                    Transfer Items
                                                                    ({{ selectedIndicatorItems(y).length }})
                                                                </b-button>
                                                            </div>
                                                            <div v-else class="float-end">
                                                                <b-skeleton width="120px" height="30px"></b-skeleton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <template
                                                        v-if="!y.indicatorItemLoading && y.fetchedIndicatorItems.length">
                                                        <div v-if="y.updateSequence">
                                                            <DraggableTree class="tree3"
                                                                :data="filterIndicatorItems(y.fetchedIndicatorItems, y.searchFilter)"
                                                                draggable="draggable" cross-tree="cross-tree"
                                                                @drop="onDropIndicatorItem($event, y)">
                                                                <div slot-scope="{data, store}">
                                                                    <template v-if="!data.isDragPlaceHolder">
                                                                        <b-card no-body class="mb-1 shadow-none"
                                                                            :class="{ 'border-radial-success': data.glow }">
                                                                            <b-card-header header-tag="header"
                                                                                role="tab" class="border">
                                                                                <div
                                                                                    class="d-flex justify-content-between align-items-center">
                                                                                    <div
                                                                                        class="d-flex align-items-center">
                                                                                        <a v-if="data.children && data.childItems.length"
                                                                                            href="javascript:void(0);"
                                                                                            @click="store.toggleOpen(data)"
                                                                                            class="me-2 font-size-15">
                                                                                            {{ data.open ? "-" : "+" }}
                                                                                        </a>
                                                                                        <div style="min-width: 30px;"
                                                                                            class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                                                                            :isDragPlaceHolder="true">
                                                                                            <h3
                                                                                                class="mb-0 position-relative">
                                                                                                {{ data.index }}</h3>
                                                                                        </div>
                                                                                        <div class="text-muted">
                                                                                            <h5 class="mb-0 d-inline">
                                                                                                {{
                                                                                                    data.indicatorItemName
                                                                                                }}
                                                                                            </h5>
                                                                                            <span
                                                                                                class="badge bg-purple ms-2"
                                                                                                style="vertical-align: top">
                                                                                                {{
                                                                                                    data.indicatorItemClassification
                                                                                                }}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </b-card-header>
                                                                        </b-card>
                                                                    </template>
                                                                </div>
                                                            </DraggableTree>
                                                        </div>
                                                        <div v-else>
                                                            <DraggableTree class="tree3"
                                                                :data="filterIndicatorItems(y.fetchedIndicatorItems, y.searchFilter)">
                                                                <div slot-scope="{data, store}">
                                                                    <template v-if="!data.isDragPlaceHolder">
                                                                        <b-card no-body class="mb-1 shadow-none"
                                                                            :class="{ 'border-radial-success': data.glow }">
                                                                            <RawData :data="{
                                                                                id: data.id,
                                                                                childItems: data.childItems,
                                                                                indicatorItemClassification: data.indicatorItemClassification,
                                                                                annualTargets: data.annualTargets,
                                                                                kpiAnnualTargets: data.kpiAnnualTargets,
                                                                                kpiBaseLines: data.kpiBaseLines,
                                                                                baselineId: data.baselineId,
                                                                                baseline: data.baseline,
                                                                                indicatorItemName: data.indicatorItemName,
                                                                                logs: data.indicatorItemLogs,
                                                                                index: data.index
                                                                            }" />
                                                                            <div class="hidden-indicator-item d-flex align-items-center justify-content-center hover-toggle"
                                                                                v-if="data.hidden">
                                                                                <a href="javascript:void(0)"
                                                                                    class="font-size-18 align-items-center text-muted border border-2 px-2 py-1 rounded hover-content"
                                                                                    @click="hideIndicatorItem(data)">
                                                                                    <i class="mdi mdi-eye me-1"></i>
                                                                                    Unhide Item
                                                                                </a>
                                                                            </div>
                                                                            <b-card-header header-tag="header"
                                                                                role="tab" class="border">
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                    <div class="d-flex w-100">
                                                                                        <a v-if="data.children && data.childItems.length"
                                                                                            href="javascript:void(0);"
                                                                                            @click="store.toggleOpen(data)"
                                                                                            class="me-2 font-size-15">
                                                                                            {{ data.open ? "-" : "+" }}
                                                                                        </a>
                                                                                        <div class="form-check form-checkbox-outline form-check-success mb-0 align-items-center"
                                                                                            v-if="y.multipleSelection">
                                                                                            <input type="checkbox"
                                                                                                :id="`selection${data.id}`"
                                                                                                checked="checked"
                                                                                                class="form-check-input"
                                                                                                v-model="data.isSelected" />
                                                                                            <label
                                                                                                :for="`selection${data.id}`"
                                                                                                class="form-check-label">
                                                                                                <div style="min-width:30px;height:35px;"
                                                                                                    class="bg-success bg-gradient text-center me-2 py-1 position-relative cursor-pointer">
                                                                                                    <h3
                                                                                                        class="mb-0 position-relative">
                                                                                                        {{ data.index }}
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div style="min-width:30px;height:35px;"
                                                                                            class="bg-success bg-gradient text-center me-2 py-1 px-1 position-relative grab-cursor"
                                                                                            @mousedown="handleMouseDown($event, data, y)"
                                                                                            @mouseup="handleMouseUp($event, data)"
                                                                                            v-if="!y.multipleSelection">
                                                                                            <h3
                                                                                                class="mb-0 position-relative">
                                                                                                {{ data.index }}</h3>
                                                                                            <span v-if="data.showInPRE"
                                                                                                class=" position-absolute"
                                                                                                style="top:-9px;right:-9px;">
                                                                                                <img src="@/assets/images/verified-icon.png"
                                                                                                    alt="verified"
                                                                                                    style="height:18px;">
                                                                                            </span>
                                                                                        </div>
                                                                                        <div class="text-muted"
                                                                                            style="flex: 1">
                                                                                            <h5 class="mb-0 d-inline">{{
                                                                                                data.indicatorItemName
                                                                                            }}</h5>
                                                                                            <sup class="font-size-12 text-yellow"
                                                                                                v-if="data.code">
                                                                                                [{{ data.code }}]
                                                                                            </sup>
                                                                                            <span
                                                                                                class="badge bg-purple ms-1"
                                                                                                style="vertical-align: top">
                                                                                                {{
                                                                                                    data.indicatorItemClassification
                                                                                                        ?
                                                                                                        data.indicatorItemClassification.classification
                                                                                                        : ''
                                                                                                }}
                                                                                            </span>
                                                                                            <span
                                                                                                class="badge bg-dark text-white ms-1"
                                                                                                style="vertical-align: top">
                                                                                                {{ data.type }}
                                                                                            </span>
                                                                                            <div>
                                                                                                <b
                                                                                                    class="me-1">Tags:</b>
                                                                                                <div class="d-inline">
                                                                                                    <span
                                                                                                        class="badge bg-success me-1 font-size-11"
                                                                                                        v-for="x in data.tags"
                                                                                                        :key="x.id"
                                                                                                        :title="x.name">
                                                                                                        {{ x.name
                                                                                                        }}<span
                                                                                                            class="ms-3 cursor-pointer"
                                                                                                            @click="deleteTag(x, data)"><i
                                                                                                                class="bx bx-x-circle text-danger"></i></span>
                                                                                                    </span>
                                                                                                    <span
                                                                                                        class="badge bg-secondary p-1 cursor-pointer"
                                                                                                        @click="addTags(data)">
                                                                                                        <i
                                                                                                            class="bx bxs-purchase-tag-alt"></i>
                                                                                                        Add <span
                                                                                                            v-if="data.tags.length > 0">More</span>
                                                                                                        Tags
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="mt-1">
                                                                                                <div
                                                                                                    class="d-flex justify-content-between align-items-start">
                                                                                                    <div class="w-50">
                                                                                                        <div>
                                                                                                            <template
                                                                                                                v-if="data.editBaseline">
                                                                                                                <span
                                                                                                                    class="d-flex align-items-center"
                                                                                                                    style="gap:2px;">KPI
                                                                                                                    Baseline:
                                                                                                                    <masked-input
                                                                                                                        type="text"
                                                                                                                        class="form-control form-control-sm text-center"
                                                                                                                        style="width:50px"
                                                                                                                        v-model="data.baselineCopy"
                                                                                                                        :mask="currencyMask" />
                                                                                                                    <a href="javascript:void(0);"
                                                                                                                        class="hover-underline text-success"
                                                                                                                        @click="saveBaseline(data)">[Save]</a>
                                                                                                                    <a href="javascript:void(0);"
                                                                                                                        class="hover-underline text-warning"
                                                                                                                        @click="data.editBaseline = false;">[Cancel]</a>
                                                                                                                </span>
                                                                                                            </template>
                                                                                                            <template
                                                                                                                v-else>
                                                                                                                <span>KPI
                                                                                                                    Baseline:
                                                                                                                    {{
                                                                                                                        data.baseline
                                                                                                                            ?
                                                                                                                            data.baseline
                                                                                                                            :
                                                                                                                            '-'
                                                                                                                    }}
                                                                                                                    <a href="javascript:void(0);"
                                                                                                                        class="hover-underline"
                                                                                                                        @click="data.editBaseline = true;">[Edit]</a>
                                                                                                                </span>
                                                                                                            </template>
                                                                                                        </div>
                                                                                                        <small
                                                                                                            class="d-flex align-items-center">
                                                                                                            <a href="javascript: void(0);"
                                                                                                                class="text-warning d-flex align-items-center"
                                                                                                                @click="showMainTargets(data, 'target')">
                                                                                                                {{
                                                                                                                    data.targetVisible
                                                                                                                        ? "Hide"
                                                                                                                        : "Show"
                                                                                                                }}
                                                                                                                Targets
                                                                                                                <i class="bx bx-chevron-right rotate font-size-14"
                                                                                                                    :class="{ 'rotate-90': data.targetVisible }"></i>
                                                                                                            </a>
                                                                                                            <span
                                                                                                                class="mx-1">|</span>
                                                                                                            <a href="javascript: void(0);"
                                                                                                                class="text-green d-flex align-items-center ms-1"
                                                                                                                @click="showKpiDetails(data, 'details')">
                                                                                                                {{
                                                                                                                    data.detailVisible
                                                                                                                        ? "Hide"
                                                                                                                        : "Show"
                                                                                                                }}
                                                                                                                Details
                                                                                                                <i class="bx bx-chevron-right rotate font-size-14"
                                                                                                                    :class="{ 'rotate-90': data.detailVisible }"></i>
                                                                                                            </a>
                                                                                                            <!-- v-if="!data.allowDeliveryUnitToAddTag" -->
                                                                                                        </small>
                                                                                                    </div>
                                                                                                    <div class="w-50 d-flex flex-row-reverse pe-2"
                                                                                                        v-if="!data.detailVisible">
                                                                                                        <TableAnnualTarget
                                                                                                            :tableData="data.kpiAnnualTargets"
                                                                                                            :loading="false"
                                                                                                            :cycles="years" />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="d-flex"
                                                                                        v-if="!y.multipleSelection"
                                                                                        style="width:5px;">
                                                                                        <a href="javascript:void(0);"
                                                                                            class="pt-2"
                                                                                            :id="`ii${data.id}`">
                                                                                            <i
                                                                                                class="fas fa-ellipsis-v"></i>
                                                                                        </a>
                                                                                        <b-popover
                                                                                            :target="`ii${data.id}`"
                                                                                            triggers="click blur"
                                                                                            placement="bottom left"
                                                                                            custom-class="dropdown-popover"
                                                                                            :show.sync="data.showActions">
                                                                                            <ul
                                                                                                style="list-style:none;padding:0;margin:0">
                                                                                                <!-- <li  @click="viewTargets(data.id)" v-if="$store.state.decrypt.isAdmin()">
                                                                                                    <a href="javascript:void(0);" class="dropdown-item text-dark">
                                                                                                        <i class="mdi mdi-view-list font-size-18 me-1"></i>View Targets
                                                                                                    </a>
                                                                                                </li> -->
                                                                                                <li
                                                                                                    @click="transferIndicatorItems([data], y)">
                                                                                                    <a href="javascript:void(0);"
                                                                                                        class="dropdown-item text-success d-flex align-items-center">
                                                                                                        <i
                                                                                                            class="mdi mdi-arrow-left font-size-18 me-1"></i>Transfer
                                                                                                        Indicator Item
                                                                                                    </a>
                                                                                                </li>
                                                                                                <li
                                                                                                    @click="showLogs(data)">
                                                                                                    <a href="javascript:void(0);"
                                                                                                        class="dropdown-item text-secondary d-flex align-items-center">
                                                                                                        <i
                                                                                                            class="mdi mdi-receipt font-size-18 me-1"></i>Show
                                                                                                        Logs
                                                                                                    </a>
                                                                                                </li>
                                                                                                <li
                                                                                                    @click="updateIndicatorItem(data, y)">
                                                                                                    <a href="javascript:void(0);"
                                                                                                        class="dropdown-item text-dark d-flex align-items-center">
                                                                                                        <i
                                                                                                            class="mdi mdi-update font-size-18 me-1"></i>Edit
                                                                                                    </a>
                                                                                                </li>
                                                                                                <li
                                                                                                    @click="deleteIndicatorItem(data, y)">
                                                                                                    <a href="javascript:void(0);"
                                                                                                        class="dropdown-item text-danger d-flex align-items-center">
                                                                                                        <i
                                                                                                            class="mdi mdi-trash-can font-size-18 me-1"></i>Delete
                                                                                                    </a>
                                                                                                </li>
                                                                                                <li
                                                                                                    @click="hideIndicatorItem(data)">
                                                                                                    <a href="javascript:void(0);"
                                                                                                        class="dropdown-item d-flex align-items-center">
                                                                                                        <i
                                                                                                            class="mdi mdi-eye-off font-size-18 me-1"></i>Hide
                                                                                                        KPI
                                                                                                    </a>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </b-popover>
                                                                                    </div>
                                                                                </div>
                                                                            </b-card-header>
                                                                            <b-collapse
                                                                                :visible="data.indicatorItemVisibility"
                                                                                :accordion="`detail-accordion-${data.id}`"
                                                                                role="tabpanel">
                                                                                <b-card-body class="border"
                                                                                    v-if="data.detailVisible">
                                                                                    <div
                                                                                        class="d-flex justify-content-between">
                                                                                        <div>
                                                                                            <div
                                                                                                class="d-flex align-items-center mb-1">
                                                                                                <span
                                                                                                    class="d-flex align-items-center border p-1 me-2">
                                                                                                    <i class="bx font-size-18 font-weight-bolder"
                                                                                                        :class="{ 'bx-check text-success': data.isPercentage, 'bx-x text-danger': !data.isPercentage }"></i>
                                                                                                    <div>Percentage
                                                                                                    </div>
                                                                                                </span>
                                                                                                <span
                                                                                                    class="d-flex align-items-center border p-1 me-2">
                                                                                                    <i class="bx font-size-18 font-weight-bolder"
                                                                                                        :class="{ 'bx-check text-success': data.isCompleted, 'bx-x text-danger': !data.isCompleted }"></i>
                                                                                                    <div>Completed</div>
                                                                                                </span>
                                                                                                <span
                                                                                                    class="d-flex align-items-center border p-1 me-1">
                                                                                                    <i class="bx font-size-18 font-weight-bolder"
                                                                                                        :class="{ 'bx-check text-success': data.isRecurring, 'bx-x text-danger': !data.isRecurring }"></i>
                                                                                                    <div>Recurring</div>
                                                                                                </span>
                                                                                            </div>
                                                                                            <b-row class="mb-2">
                                                                                                <b-col sm="12">
                                                                                                    <b class="me-1">KPI
                                                                                                        Classification:</b>
                                                                                                    <u>{{
                                                                                                        data.indicatorItemClassification
                                                                                                            ?
                                                                                                            data.indicatorItemClassification.classification
                                                                                                            : ''
                                                                                                    }}</u>
                                                                                                </b-col>
                                                                                            </b-row>
                                                                                            <b-row class="mb-2">
                                                                                                <b-col sm="12">
                                                                                                    <b class="me-1">Year
                                                                                                        to be
                                                                                                        complied:</b>
                                                                                                    <u>{{
                                                                                                        data.yearToBeComplied
                                                                                                    }}</u>
                                                                                                </b-col>
                                                                                                <b-col></b-col>
                                                                                            </b-row>
                                                                                            <b-row class="mb-2">
                                                                                                <b-col sm="12">
                                                                                                    <b class="me-1">Final
                                                                                                        Remarks:</b>
                                                                                                    <u>{{
                                                                                                        data.finalRemarks
                                                                                                    }}</u>
                                                                                                </b-col>
                                                                                            </b-row>
                                                                                        </div>
                                                                                        <div>
                                                                                            <TableAnnualTarget
                                                                                                :tableData="data.annualTargets"
                                                                                                :loading="data.anTargetLoading"
                                                                                                :canAct="true"
                                                                                                :cycles="years"
                                                                                                @save="saveAnnualTarget($event, { id: data.id, annualTargets: data.annualTargets, kpiAnnualTargets: data.kpiAnnualTargets })"
                                                                                                @delete="removeAnnualTarget($event, { annualTargets: data.annualTargets, kpiAnnualTargets: data.kpiAnnualTargets })" />
                                                                                        </div>
                                                                                    </div>
                                                                                </b-card-body>
                                                                                <b-card-body class="border"
                                                                                    v-if="data.targetVisible">
                                                                                    <div
                                                                                        class="d-flex align-items-end justify-content-between">
                                                                                        <div>
                                                                                            <h4 class="m-0">Target List
                                                                                            </h4>
                                                                                            <small
                                                                                                v-if="$store.state.decrypt.isAdmin()"><a
                                                                                                    href="javascript:void(0);"
                                                                                                    class="text-secondary"
                                                                                                    @click="multipleSelectTargets(data)">{{
                                                                                                        data.singleSelection
                                                                                                            ? `Single` :
                                                                                                            `Multiple` }}
                                                                                                    Selection</a></small>
                                                                                            <div class="form-check form-checkbox-outline form-check-success mb-0"
                                                                                                v-if="!data.singleSelection">
                                                                                                <input type="checkbox"
                                                                                                    :id="`select-all-target`"
                                                                                                    class="form-check-input"
                                                                                                    :checked="data.mainTargets.length == data.selectedTargets.length"
                                                                                                    @change="selectAllMainTarget(data, $event)" /><label
                                                                                                    :for="`select-all-target`"
                                                                                                    class="form-check-label">
                                                                                                    <span>Select All
                                                                                                        Targets</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="d-flex">
                                                                                            <button type="button"
                                                                                                class="btn btn-success me-1"
                                                                                                @click="transferMainTarget(data.selectedTargets, data, y)"
                                                                                                v-if="data.selectedTargets.length">
                                                                                                <i
                                                                                                    class="bx bx-transfer"></i>Transfer
                                                                                                Selected
                                                                                            </button>
                                                                                            <button type="button"
                                                                                                class="btn btn-danger me-1"
                                                                                                @click="deleteMainTarget(data.selectedTargets, data)"
                                                                                                v-if="data.selectedTargets.length">
                                                                                                <i
                                                                                                    class="bx bx-minus"></i>Remove
                                                                                                Selected
                                                                                            </button>
                                                                                            <button type="button"
                                                                                                class="btn btn-primary"
                                                                                                @click="createNewTarget(data)">
                                                                                                <i
                                                                                                    class="bx bx-plus"></i>Create
                                                                                                New Target Template
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-if="data.mainTargetLoading"
                                                                                        class="d-flex justify-content-center align-items-center my-5">
                                                                                        <div
                                                                                            class="preloader-component me-2">
                                                                                            <div class="status">
                                                                                                <div
                                                                                                    class="spinner-chase w-20px h-20px">
                                                                                                    <div
                                                                                                        class="chase-dot">
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="chase-dot">
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="chase-dot">
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="chase-dot">
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="chase-dot">
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="chase-dot">
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <strong>Loading...</strong>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        <MainTargetTemplate
                                                                                            :fromTemplate="true"
                                                                                            :allowText="data.allowText"
                                                                                            :mainTargets="data.mainTargets"
                                                                                            :singleSelection="data.singleSelection"
                                                                                            :mandatory="data.indicatorItemClassification && data.indicatorItemClassification.classification ? data.indicatorItemClassification.classification.toLowerCase().includes('mandatory') : false"
                                                                                            @delete="deleteMainTarget([$event], data)"
                                                                                            @post="postMainTarget($event, data)"
                                                                                            @update="updateMainTarget($event, data)"
                                                                                            @open-imports="openImports($event, data)"
                                                                                            :ref="`mainTargetTemplate${data.id}`"
                                                                                            @view-apis="viewAPIs"
                                                                                            @view-rubric="viewRubric"
                                                                                            @selectTarget="selectTarget($event, data)"
                                                                                            @unpost-target="unpostTarget"
                                                                                            @show-logs="showLogs" />

                                                                                    </div>
                                                                                </b-card-body>
                                                                            </b-collapse>
                                                                        </b-card>
                                                                    </template>
                                                                </div>
                                                            </DraggableTree>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-if="!y.indicatorItemLoading && !y.fetchedIndicatorItems.length">
                                                        No data found.
                                                    </template>
                                                </b-tab>
                                                <b-tab title-item-class="mb-2" @click="addIndicator(x)">
                                                    <template v-slot:title>
                                                        <div class="text-center"><i class="bx bx-plus"></i>Add More PAP
                                                        </div>
                                                    </template>
                                                </b-tab>
                                            </b-tabs>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <api-classification ref="iitemClass" @dropData="dropClass($event)"></api-classification>
        <print-options ref="printOpt"></print-options>
        <kpi-tags ref="kpiTags" @drop-data="dropKpiTags"></kpi-tags>
        <PlanningRatingScale :fromTemplate="true" ref="PlanningRatingScale" />
        <PrexcModal ref="prexcModal" @dropData="dropProgramArea" />
        <UploadModal @upload-excel="uploadKpi" />
        <LogModal ref="logModal" />
    </Layout>
</template>